import { request , gql } from "graphql-request";

import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders } from "utils/helpers";

const queryFn = (
    accessToken: string,
    data: {
        reportFiltersetUid: string | null;
    }
) =>
    request<{
        prefilteredReports?: {
            prefilteredRecommendationsReport: {
                annualEmissionSavingsByMeasureTypeChart: AnnualEmissionSavingsByMeasureChartData;
            };
        };
    }>({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
            reportFiltersetUid: data.reportFiltersetUid,
        },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then(
        (data) =>
            (data.prefilteredReports?.prefilteredRecommendationsReport
                .annualEmissionSavingsByMeasureTypeChart as AnnualEmissionSavingsByMeasureChartData) ||
            null
    );

const query = gql`
    query annualEmissionSavingsByMeasureTypeChart($reportFiltersetUid: Uuid) {
        prefilteredReports(reportFiltersetUid: $reportFiltersetUid) {
            prefilteredRecommendationsReport {
                annualEmissionSavingsByMeasureTypeChart {
                    carbonEmissionSavingsFromGrid
                    carbonReductionMeasureCategories {
                        carbonReductionMeasureCategory
                        totalCarbonEmissionSavings
                    }
                    remainingCarbonEmissions
                    year
                }
            }
        }
    }
`;

export default queryFn;
